export class PopupOwnership {
    constructor() {
        this.heldBy = null
        this.onDisplaced = null
    }

    claim(claimant, { replace = false, onDisplaced = null } = {}) {
        if (this.heldBy != null && this.heldBy !== claimant && !replace) {
            return false
        }

        if (this.heldBy != null && this.heldBy !== claimant) {
            this.onDisplaced?.()
        }

        this.heldBy = claimant
        this.onDisplaced = onDisplaced

        return true
    }

    release(claimant) {
        if (this.heldBy !== claimant) {
            return
        }

        this.heldBy = null
        this.onDisplaced = null
    }
}
